import React, { useEffect } from 'react';
import Layout from '../layout/Layout';
import Header from '../components/Header';
import Footer from '../components/Footer';
import DatosContacto from '../components/DatosContacto';
import ContactForm from '../components/ContactForm';
import { loadCSS } from '../utils/cssLoader';

export default function Contacto() {
    
    // Load CSS files for Contacto page
    useEffect(() => {
        loadCSS('Contacto.css');
        loadCSS('DatosContacto.css');
        
        // Inyectar estilos críticos inmediatamente
        const criticalStyles = `
            .contacto-container {
                position: relative !important;
                width: 100% !important;
                padding: 2rem 0 !important;
                font-family: 'Montserrat', 'Inter', sans-serif !important;
                display: block !important;
                visibility: visible !important;
                opacity: 1 !important;
                z-index: 999 !important;
            }
            .contacto {
                background: linear-gradient(135deg, 
                    rgba(255, 255, 255, 0.95) 0%, 
                    rgba(248, 250, 252, 0.9) 30%,
                    rgba(226, 232, 240, 0.85) 70%, 
                    rgba(219, 234, 254, 0.8) 100%) !important;
                backdrop-filter: blur(25px) saturate(1.2) !important;
                border-radius: 3.5rem !important;
                box-shadow: 
                    0 32px 64px rgba(0, 0, 0, 0.1),
                    0 16px 48px rgba(30, 64, 175, 0.15),
                    0 8px 32px rgba(59, 130, 246, 0.08),
                    inset 0 1px 0 rgba(255, 255, 255, 0.6),
                    inset 0 -1px 0 rgba(59, 130, 246, 0.1) !important;
                padding: 5rem 4rem !important;
                margin: 4rem auto !important;
                max-width: 1200px !important;
                border: 2px solid rgba(59, 130, 246, 0.15) !important;
                position: relative !important;
                overflow: hidden !important;
                display: block !important;
                visibility: visible !important;
                opacity: 1 !important;
                z-index: 100 !important;
            }
            .contacto-header {
                text-align: center !important;
                margin-bottom: 4rem !important;
                position: relative !important;
                z-index: 2 !important;
            }
            .contacto-header h2 {
                font-size: clamp(2.5rem, 6vw, 4rem) !important;
                font-weight: 800 !important;
                color: #10b981 !important;
                margin-bottom: 1.5rem !important;
                letter-spacing: -0.025em !important;
                font-family: 'Montserrat', 'Inter', sans-serif !important;
            }
            .contacto-subtitle {
                font-size: clamp(1.1rem, 3vw, 1.4rem) !important;
                color: #64748b !important;
                max-width: 600px !important;
                margin: 0 auto 2rem !important;
                line-height: 1.6 !important;
                font-weight: 400 !important;
            }
            .contacto-decoracion {
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 1rem !important;
                margin-bottom: 2rem !important;
            }
            .decoracion-punto {
                width: 8px !important;
                height: 8px !important;
                background: #10b981 !important;
                border-radius: 50% !important;
            }
            .decoracion-linea {
                width: 100px !important;
                height: 2px !important;
                background: linear-gradient(90deg, #10b981, #059669) !important;
            }
            .contacto-opciones {
                display: grid !important;
                grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)) !important;
                gap: 2rem !important;
                margin-bottom: 4rem !important;
                position: relative !important;
                z-index: 2 !important;
                visibility: visible !important;
                opacity: 1 !important;
            }
            .contacto-opcion {
                position: relative !important;
                transform: translateY(0) !important;
                transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1) !important;
            }
            .contacto-link {
                display: flex !important;
                align-items: center !important;
                padding: 2rem !important;
                background: rgba(255, 255, 255, 0.8) !important;
                border-radius: 2rem !important;
                text-decoration: none !important;
                color: inherit !important;
                box-shadow: 
                    0 16px 32px rgba(0, 0, 0, 0.08),
                    0 8px 24px rgba(16, 185, 129, 0.12) !important;
                border: 1px solid rgba(255, 255, 255, 0.5) !important;
                backdrop-filter: blur(15px) !important;
                transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1) !important;
                position: relative !important;
                overflow: hidden !important;
                visibility: visible !important;
                opacity: 1 !important;
                z-index: 10 !important;
            }
            .contacto-link:hover {
                transform: translateY(-4px) !important;
                box-shadow: 
                    0 24px 48px rgba(0, 0, 0, 0.12),
                    0 12px 32px rgba(16, 185, 129, 0.2) !important;
                background: rgba(255, 255, 255, 0.95) !important;
            }
            .contacto-icon-wrapper {
                width: 70px !important;
                height: 70px !important;
                background: linear-gradient(135deg, #10b981, #059669) !important;
                border-radius: 20px !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                margin-right: 1.5rem !important;
                position: relative !important;
                box-shadow: 0 8px 24px rgba(16, 185, 129, 0.3) !important;
            }
            .contacto-icon-wrapper svg {
                color: white !important;
            }
            .icon-pulse {
                position: absolute !important;
                top: 50% !important;
                left: 50% !important;
                width: 100% !important;
                height: 100% !important;
                border-radius: 20px !important;
                background: rgba(16, 185, 129, 0.4) !important;
                transform: translate(-50%, -50%) !important;
                animation: pulse 2s infinite !important;
            }
            @keyframes pulse {
                0% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
                70% { transform: translate(-50%, -50%) scale(1.4); opacity: 0; }
                100% { transform: translate(-50%, -50%) scale(1.4); opacity: 0; }
            }
            .contacto-info {
                flex: 1 !important;
            }
            .contacto-label {
                font-size: 1.25rem !important;
                font-weight: 700 !important;
                color: #1e293b !important;
                margin-bottom: 0.5rem !important;
                font-family: 'Montserrat', 'Inter', sans-serif !important;
            }
            .contacto-value {
                font-size: 1rem !important;
                color: #64748b !important;
                font-weight: 500 !important;
                margin: 0 !important;
            }
            .contacto-arrow {
                width: 40px !important;
                height: 40px !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                color: #64748b !important;
                transition: all 0.3s ease !important;
            }
            .contacto-link:hover .contacto-arrow {
                transform: translateX(4px) !important;
                color: #10b981 !important;
            }
            .contacto-footer {
                text-align: center !important;
                position: relative !important;
                z-index: 2 !important;
            }
            .contacto-cta {
                font-size: 1.1rem !important;
                color: #64748b !important;
                margin: 0 !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 0.5rem !important;
                font-weight: 500 !important;
            }
            .cta-icon {
                font-size: 1.25rem !important;
            }
            @media (max-width: 768px) {
                .contacto {
                    padding: 3rem 2rem !important;
                    margin: 2rem 1rem !important;
                    border-radius: 2.5rem !important;
                }
                .contacto-opciones {
                    grid-template-columns: 1fr !important;
                    gap: 1.5rem !important;
                }
                .contacto-link {
                    padding: 1.5rem !important;
                }
                .contacto-icon-wrapper {
                    width: 60px !important;
                    height: 60px !important;
                    margin-right: 1rem !important;
                }
            }
            
            /* Forzar visibilidad específicamente en página contacto */
            .contacto-container,
            .contacto,
            .contacto-opciones,
            .contacto-link,
            .contacto-opcion {
                display: block !important;
                visibility: visible !important;
                opacity: 1 !important;
                position: relative !important;
            }
            
            .contacto-opciones {
                display: grid !important;
            }
            
            .contacto-link {
                display: flex !important;
            }
            
            /* Reset conflicting styles */
            section.contacto {
                all: unset !important;
                background: linear-gradient(135deg, 
                    rgba(255, 255, 255, 0.95) 0%, 
                    rgba(248, 250, 252, 0.9) 30%,
                    rgba(226, 232, 240, 0.85) 70%, 
                    rgba(219, 234, 254, 0.8) 100%) !important;
                backdrop-filter: blur(25px) saturate(1.2) !important;
                border-radius: 3.5rem !important;
                box-shadow: 
                    0 32px 64px rgba(0, 0, 0, 0.1),
                    0 16px 48px rgba(30, 64, 175, 0.15),
                    0 8px 32px rgba(59, 130, 246, 0.08),
                    inset 0 1px 0 rgba(255, 255, 255, 0.6),
                    inset 0 -1px 0 rgba(59, 130, 246, 0.1) !important;
                padding: 5rem 4rem !important;
                margin: 4rem auto !important;
                max-width: 1200px !important;
                border: 2px solid rgba(59, 130, 246, 0.15) !important;
                position: relative !important;
                overflow: hidden !important;
                display: block !important;
                visibility: visible !important;
                opacity: 1 !important;
                z-index: 100 !important;
            }
        `;
        
        // Crear e inyectar estilos
        const styleElement = document.createElement('style');
        styleElement.textContent = criticalStyles;
        styleElement.id = 'datos-contacto-contacto-page-styles';
        
        // Remover estilos previos si existen
        const existingStyles = document.getElementById('datos-contacto-contacto-page-styles');
        if (existingStyles) {
            existingStyles.remove();
        }
        
        document.head.appendChild(styleElement);
        
        // Cleanup function
        return () => {
            const styleToRemove = document.getElementById('datos-contacto-contacto-page-styles');
            if (styleToRemove) {
                styleToRemove.remove();
            }
        };
    }, []);
    const datos = [
        {
            dato: "228 366 7786",
            logo: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            )
        },
        {
            dato: "+52 228 366 7786",
            logo: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15.46l-5.27-.61-2.52 2.52a15.045 15.045 0 0 1-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            )
        },
        {
            dato: "ventas_orsan@hotmail.com",
            logo: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            )
        },
        {
            dato: "Xalapa",
            logo: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2"/>
                </svg>
            )
        },
    ];

    return (
        <Layout>
            <div>
                <Header active="contacto" />
                <main style={{flex: 1}}>
                <div style={{ width: '100%', fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>
                    {/* Hero Section Mejorado */}
                    <div style={{
                        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.4) 100%), url("/bannerC.webp")',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        minHeight: '100vh',
                        padding: 'clamp(5rem, 10vh, 7rem) clamp(1rem, 4vw, 2rem) clamp(3rem, 8vh, 5rem)',
                        color: 'white',
                        textAlign: 'center',
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        <div style={{ 
                            maxWidth: 'min(800px, 90vw)', 
                            margin: '0 auto',
                            position: 'relative',
                            zIndex: 2,
                            width: '100%',
                            padding: '0 1rem'
                        }}>
                            <style dangerouslySetInnerHTML={{
                                __html: `
                                    @keyframes bounce {
                                        0%, 20%, 50%, 80%, 100% {
                                            transform: translateY(0);
                                        }
                                        40% {
                                            transform: translateY(-10px);
                                        }
                                        60% {
                                            transform: translateY(-5px);
                                        }
                                    }
                                    .bounce-animation {
                                        animation: bounce 2s infinite;
                                    }
                                `
                            }} />
                            <div style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                padding: 'clamp(0.5rem, 2vw, 0.6rem) clamp(1.2rem, 4vw, 1.8rem)',
                                background: 'rgba(255, 255, 255, 0.9)',
                                color: '#333333',
                                borderRadius: '50px',
                                marginBottom: 'clamp(1.5rem, 4vw, 2rem)',
                                fontSize: 'clamp(0.85rem, 2.5vw, 1rem)',
                                fontWeight: '600',
                                letterSpacing: '0.3px',
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
                            }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="bounce-animation">
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <polyline points="9,22 9,12 15,12 15,22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Tu futuro hogar te espera
                            </div>
                            
                            <h1 style={{
                                fontSize: 'clamp(2.5rem, 8vw, 4.5rem)',
                                fontWeight: '800',
                                marginBottom: 'clamp(1.5rem, 4vw, 2rem)',
                                letterSpacing: '-0.02em',
                                color: 'white',
                                textShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                                lineHeight: 1.1
                            }}>
                                Contáctanos
                            </h1>
                            
                            <p style={{
                                fontSize: 'clamp(1rem, 3vw, 1.4rem)',
                                fontWeight: '300',
                                lineHeight: 1.6,
                                opacity: 0.95,
                                maxWidth: 'min(650px, 90vw)',
                                margin: '0 auto clamp(2rem, 5vw, 3rem)',
                                textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                                padding: '0 1rem'
                            }}>
                                Puedes agendar citas, enviar preguntas o solicitar asesoría de manera rápida. Estamos aquí para ayudarte con todas tus necesidades inmobiliarias
                            </p>

                            {/* Botones de acción mejorados */}
                            <div style={{
                                display: 'flex',
                                gap: 'clamp(1rem, 3vw, 1.5rem)',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                flexDirection: window.innerWidth < 640 ? 'column' : 'row',
                                alignItems: 'center'
                            }}>
                                <a href="#formulario" style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 'clamp(0.5rem, 2vw, 0.7rem)',
                                    padding: 'clamp(1rem, 3vw, 1.2rem) clamp(1.8rem, 5vw, 2.5rem)',
                                    background: 'white',
                                    color: '#333333',
                                    textDecoration: 'none',
                                    borderRadius: '50px',
                                    fontWeight: '600',
                                    fontSize: 'clamp(0.9rem, 2.5vw, 1.05rem)',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
                                    border: '2px solid transparent',
                                    width: window.innerWidth < 640 ? '100%' : 'auto',
                                    maxWidth: window.innerWidth < 640 ? '280px' : 'none',
                                    justifyContent: 'center'
                                }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Enviar mensaje
                                </a>
                                <a href="tel:2283667786" style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 'clamp(0.5rem, 2vw, 0.7rem)',
                                    padding: 'clamp(1rem, 3vw, 1.2rem) clamp(1.8rem, 5vw, 2.5rem)',
                                    background: 'rgba(255, 255, 255, 0.15)',
                                    color: 'white',
                                    textDecoration: 'none',
                                    borderRadius: '50px',
                                    fontWeight: '600',
                                    fontSize: 'clamp(0.9rem, 2.5vw, 1.05rem)',
                                    transition: 'all 0.3s ease',
                                    backdropFilter: 'blur(10px)',
                                    border: '2px solid rgba(255, 255, 255, 0.3)',
                                    width: window.innerWidth < 640 ? '100%' : 'auto',
                                    maxWidth: window.innerWidth < 640 ? '280px' : 'none',
                                    justifyContent: 'center'
                                }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Llamar ahora
                                </a>
                            </div>
                        </div>
                    </div>
                    
                    {/* Formulario con diseño premium */}
                    <div id="formulario" style={{ 
                        padding: 'clamp(4rem, 8vw, 6rem) clamp(1rem, 4vw, 2rem)',
                        background: 'linear-gradient(135deg, #ffffff 0%, #f9f9f9 50%, #f5f5f5 100%)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        {/* Elementos decorativos */}
                        <div style={{
                            position: 'absolute',
                            top: '-50px',
                            left: '-50px',
                            width: '200px',
                            height: '200px',
                            background: 'rgba(0, 0, 0, 0.02)',
                            borderRadius: '50%',
                            filter: 'blur(30px)',
                            zIndex: 1
                        }}></div>
                        <div style={{
                            position: 'absolute',
                            bottom: '-100px',
                            right: '-100px',
                            width: '300px',
                            height: '300px',
                            background: 'rgba(0, 0, 0, 0.01)',
                            borderRadius: '50%',
                            filter: 'blur(40px)',
                            zIndex: 1
                        }}></div>

                        <div style={{ position: 'relative', zIndex: 2 }}>
                            <ContactForm titulo="Envíanos un mensaje"
                                frase="Estamos aquí para ayudarte. Contáctanos y te responderemos pronto." />
                        </div>
                    </div>
                </div>
                {/*SECCIÓN DE OFICINAS MEJORADA*/}
                <section style={{
                    padding: 'clamp(4rem, 8vw, 6rem) clamp(1rem, 4vw, 2rem)',
                    background: 'linear-gradient(135deg, #f8f8f8 0%, #ffffff 100%)',
                    position: 'relative'
                }}>
                    <div style={{ 
                        maxWidth: 'min(1400px, 95vw)', 
                        margin: '0 auto',
                        position: 'relative',
                        zIndex: 2
                    }}>
                        {/* Título de sección premium */}
                        <div style={{ textAlign: 'center', marginBottom: 'clamp(3rem, 8vw, 5rem)' }}>
                            <div style={{
                                display: 'inline-block',
                                padding: 'clamp(0.5rem, 2vw, 0.7rem) clamp(1.5rem, 4vw, 2rem)',
                                background: 'rgba(0, 0, 0, 0.05)',
                                borderRadius: '50px',
                                marginBottom: 'clamp(1.5rem, 4vw, 2rem)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(0, 0, 0, 0.1)',
                                color: '#666666',
                                fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                                fontWeight: '600',
                                letterSpacing: '0.5px'
                            }}>
                                📍 Ubicación
                            </div>
                            
                            <h2 style={{
                                fontFamily: 'Inter, sans-serif',
                                fontWeight: '800',
                                fontSize: 'clamp(2rem, 6vw, 3.5rem)',
                                color: '#333333',
                                marginBottom: 'clamp(1rem, 3vw, 1.5rem)',
                                letterSpacing: '-0.03em'
                            }}>
                                Nuestra Oficina
                            </h2>
                            
                            <p style={{
                                color: '#666666',
                                fontSize: 'clamp(1rem, 3vw, 1.2rem)',
                                maxWidth: 'min(600px, 90vw)',
                                margin: '0 auto',
                                lineHeight: 1.6,
                                padding: '0 1rem'
                            }}>
                                Visítanos en el corazón de Xalapa y descubre cómo podemos ayudarte
                            </p>

                            <div style={{
                                width: 'clamp(80px, 15vw, 120px)',
                                height: '4px',
                                background: 'linear-gradient(90deg, #333333, #666666)',
                                margin: 'clamp(1.5rem, 4vw, 2rem) auto 0',
                                borderRadius: '2px'
                            }}></div>
                        </div>

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(min(400px, 100vw), 1fr))',
                            gap: 'clamp(2rem, 5vw, 4rem)',
                            alignItems: 'start'
                        }}>
                            {/* Información de la oficina mejorada */}
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.95)',
                                borderRadius: 'clamp(16px, 4vw, 24px)',
                                padding: 'clamp(2rem, 5vw, 3.5rem)',
                                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2), 0 8px 32px rgba(0, 0, 0, 0.1)',
                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                backdropFilter: 'blur(20px)',
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                {/* Elemento decorativo interno */}
                                <div style={{
                                    position: 'absolute',
                                    top: '-50px',
                                    right: '-50px',
                                    width: '150px',
                                    height: '150px',
                                    background: 'rgba(0, 0, 0, 0.02)',
                                    borderRadius: '50%',
                                    filter: 'blur(30px)'
                                }}></div>

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: 'clamp(2rem, 4vw, 2.5rem)',
                                    position: 'relative',
                                    zIndex: 1,
                                    flexDirection: window.innerWidth < 480 ? 'column' : 'row',
                                    textAlign: window.innerWidth < 480 ? 'center' : 'left'
                                }}>
                                    <div style={{
                                        width: 'clamp(50px, 12vw, 70px)',
                                        height: 'clamp(50px, 12vw, 70px)',
                                        background: 'linear-gradient(135deg, #333333, #666666)',
                                        borderRadius: 'clamp(12px, 4vw, 20px)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: window.innerWidth < 480 ? '0' : 'clamp(1rem, 3vw, 1.5rem)',
                                        marginBottom: window.innerWidth < 480 ? '1rem' : '0',
                                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)'
                                    }}>
                                        <svg width={window.innerWidth < 768 ? "24" : "32"} height={window.innerWidth < 768 ? "24" : "32"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="white" strokeWidth="2"/>
                                            <circle cx="12" cy="10" r="3" stroke="white" strokeWidth="2"/>
                                        </svg>
                                    </div>
                                    <h3 style={{
                                        fontFamily: 'Inter, sans-serif',
                                        fontWeight: '700',
                                        fontSize: 'clamp(1.3rem, 4vw, 1.8rem)',
                                        color: '#333333',
                                        margin: 0
                                    }}>
                                        Visítanos
                                    </h3>
                                </div>

                                <p style={{
                                    fontFamily: 'Inter, sans-serif',
                                    color: '#666666',
                                    fontSize: 'clamp(1rem, 2.5vw, 1.15rem)',
                                    lineHeight: 1.7,
                                    marginBottom: 'clamp(2rem, 4vw, 2.5rem)',
                                    position: 'relative',
                                    zIndex: 1,
                                    textAlign: window.innerWidth < 640 ? 'center' : 'left'
                                }}>
                                    En <strong style={{color: '#333333'}}>ORSAN Consorcio Inmobiliario</strong> te ofrecemos soluciones confiables y personalizadas para tu propiedad en Xalapa y la región.
                                </p>

                                {/* Horario con diseño premium */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #f9f9f9, #f0f0f0)',
                                    borderRadius: 'clamp(12px, 3vw, 16px)',
                                    padding: 'clamp(1.5rem, 4vw, 2rem)',
                                    marginBottom: 'clamp(2rem, 4vw, 2.5rem)',
                                    border: '1px solid rgba(0, 0, 0, 0.1)',
                                    position: 'relative',
                                    zIndex: 1
                                }}>
                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        marginBottom: 'clamp(0.6rem, 2vw, 0.8rem)',
                                        flexDirection: window.innerWidth < 480 ? 'column' : 'row',
                                        textAlign: window.innerWidth < 480 ? 'center' : 'left'
                                    }}>
                                        <div style={{
                                            width: 'clamp(32px, 8vw, 40px)',
                                            height: 'clamp(32px, 8vw, 40px)',
                                            background: 'linear-gradient(135deg, #333333, #666666)',
                                            borderRadius: 'clamp(8px, 2vw, 10px)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: window.innerWidth < 480 ? '0' : 'clamp(0.8rem, 2vw, 1rem)',
                                            marginBottom: window.innerWidth < 480 ? '0.8rem' : '0'
                                        }}>
                                            <svg width={window.innerWidth < 768 ? "16" : "20"} height={window.innerWidth < 768 ? "16" : "20"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2"/>
                                                <path d="M12 7v5l3 3" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                                            </svg>
                                        </div>
                                        <span style={{ 
                                            fontWeight: '700', 
                                            color: '#333333',
                                            fontSize: 'clamp(1rem, 2.5vw, 1.1rem)'
                                        }}>Horario de Atención</span>
                                    </div>
                                    <p style={{
                                        margin: 0,
                                        color: '#666666',
                                        fontSize: 'clamp(0.9rem, 2.5vw, 1.05rem)',
                                        fontWeight: '500',
                                        paddingLeft: window.innerWidth < 480 ? '0' : 'clamp(2.5rem, 6vw, 3rem)',
                                        textAlign: window.innerWidth < 480 ? 'center' : 'left'
                                    }}>
                                        Lunes a Viernes • 11:00 AM - 7:00 PM
                                    </p>
                                </div>

                                {/* Datos de contacto premium */}
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 'clamp(1rem, 2.5vw, 1.2rem)',
                                    position: 'relative',
                                    zIndex: 1
                                }}>
                                    {datos.map((item, index) => (
                                        <div key={index} style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: 'clamp(1rem, 3vw, 1.3rem)',
                                            background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.03), rgba(0, 0, 0, 0.02))',
                                            borderRadius: 'clamp(10px, 2.5vw, 12px)',
                                            border: '1px solid rgba(0, 0, 0, 0.1)',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer',
                                            flexDirection: window.innerWidth < 480 ? 'column' : 'row',
                                            textAlign: window.innerWidth < 480 ? 'center' : 'left'
                                        }}>
                                            <div style={{ 
                                                height: 'clamp(20px, 5vw, 28px)', 
                                                width: 'clamp(20px, 5vw, 28px)',
                                                marginRight: window.innerWidth < 480 ? '0' : 'clamp(1rem, 2.5vw, 1.2rem)',
                                                marginBottom: window.innerWidth < 480 ? '0.8rem' : '0',
                                                color: '#333333',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                {item.logo}
                                            </div>
                                            <span style={{ 
                                                color: '#333333', 
                                                fontWeight: '600',
                                                fontSize: 'clamp(0.9rem, 2.5vw, 1.05rem)',
                                                wordBreak: 'break-word'
                                            }}>{item.dato}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Mapa ultra moderno */}
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.95)',
                                borderRadius: 'clamp(16px, 4vw, 24px)',
                                overflow: 'hidden',
                                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2), 0 8px 32px rgba(0, 0, 0, 0.1)',
                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                backdropFilter: 'blur(20px)'
                            }}>
                                <div style={{
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3760.520409435498!2d-96.8740443247834!3d19.51925888177871!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85db33b26b5bf855%3A0x866d0699f3d892f9!2sINMUEBLES%20ORSAN!5e0!3m2!1ses-419!2smx!4v1751784020755!5m2!1ses-419!2smx"
                                        width="100%"
                                        height={window.innerWidth < 640 ? "250" : window.innerWidth < 1024 ? "300" : "350"}
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title="Ubicación de Inmuebles Orsan"
                                    ></iframe>
                                </div>
                                
                                <div style={{ padding: 'clamp(2rem, 4vw, 2.5rem)' }}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginBottom: 'clamp(1rem, 3vw, 1.5rem)',
                                        flexDirection: window.innerWidth < 480 ? 'column' : 'row',
                                        textAlign: window.innerWidth < 480 ? 'center' : 'left'
                                    }}>
                                        <div style={{
                                            width: 'clamp(40px, 10vw, 50px)',
                                            height: 'clamp(40px, 10vw, 50px)',
                                            background: 'linear-gradient(135deg, #333333, #666666)',
                                            borderRadius: 'clamp(10px, 2.5vw, 12px)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: window.innerWidth < 480 ? '0' : 'clamp(0.8rem, 2vw, 1rem)',
                                            marginBottom: window.innerWidth < 480 ? '1rem' : '0'
                                        }}>
                                            <svg width={window.innerWidth < 768 ? "20" : "24"} height={window.innerWidth < 768 ? "20" : "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="white" strokeWidth="2"/>
                                                <circle cx="12" cy="10" r="3" stroke="white" strokeWidth="2"/>
                                            </svg>
                                        </div>
                                        <h4 style={{
                                            margin: 0,
                                            color: '#333333',
                                            fontSize: 'clamp(1.1rem, 3vw, 1.3rem)',
                                            fontWeight: '700'
                                        }}>
                                            Nuestra Dirección
                                        </h4>
                                    </div>
                                    
                                    <p style={{ 
                                        color: '#666666', 
                                        fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                                        lineHeight: 1.6,
                                        marginBottom: 'clamp(1.5rem, 4vw, 2rem)',
                                        fontWeight: '500',
                                        textAlign: window.innerWidth < 640 ? 'center' : 'left'
                                    }}>
                                        P.º de los Alpes 21, Residential Las Cumbres<br/>
                                        Real del Bosque, 91190 Xalapa-Enríquez, Ver.
                                    </p>
                                    
                                    <a
                                        href="https://www.google.com/maps?q=INMUEBLES+ORSAN,+P.%C2%BA+de+los+Alpes+21,+Residential+Las+Cumbres,+Real+del+Bosque,+91190+Xalapa-Enr%C3%ADquez,+Ver."
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: 'clamp(0.6rem, 2vw, 0.8rem)',
                                            width: '100%',
                                            padding: 'clamp(1rem, 3vw, 1.2rem) clamp(1.5rem, 4vw, 2rem)',
                                            background: 'linear-gradient(135deg, #333333, #666666)',
                                            color: 'white',
                                            textDecoration: 'none',
                                            borderRadius: 'clamp(10px, 2.5vw, 12px)',
                                            fontWeight: '600',
                                            fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                                            transition: 'all 0.3s ease',
                                            border: 'none',
                                            cursor: 'pointer',
                                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)'
                                        }}
                                    >
                                        <svg width={window.innerWidth < 768 ? "16" : "20"} height={window.innerWidth < 768 ? "16" : "20"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="currentColor" strokeWidth="2"/>
                                            <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2"/>
                                        </svg>
                                        Ver en Google Maps
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <DatosContacto frase="Puedes agendar citas, enviar preguntas o solicitar asesoría de manera rápida." />
                </main>
                <div className="footer-wrapper">
                    <Footer />
                </div>
            </div>
        </Layout>
    );
}